import { forwardRef, type Ref, type SVGProps } from "react";

function SvgCheckmarkDouble(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m1.5 8.75 2.2 2.25 5.134-6"
      />
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m6.5 10 0.9 1 5.134-6"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgCheckmarkDouble);
export default ForwardRef;
